<script setup lang="ts">
import type { SlideOverStatusHelperRole } from './types';

defineProps<{
  statusHelperRole: SlideOverStatusHelperRole;
}>();
</script>

<template>
  <div
    class="backgroundImage flex h-[184px] items-center justify-center rounded-t-2xl"
  >
    <svg
      v-if="statusHelperRole === 'deactivate-campaign'"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="3" width="32" height="32" rx="16" fill="#FEE4E2" />
      <g clip-path="url(#clip0_279_4115)">
        <path
          d="M14.2866 14.2868L23.7133 23.7135M25.6666 19.0002C25.6666 22.6821 22.6819 25.6668 19 25.6668C15.3181 25.6668 12.3333 22.6821 12.3333 19.0002C12.3333 15.3183 15.3181 12.3335 19 12.3335C22.6819 12.3335 25.6666 15.3183 25.6666 19.0002Z"
          stroke="#D92D20"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <rect
        x="3"
        y="3"
        width="32"
        height="32"
        rx="16"
        stroke="#FEE4E2"
        stroke-opacity="0.4"
        stroke-width="6"
      />
      <defs>
        <clipPath id="clip0_279_4115">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(11 11)"
          />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="
        ['join-campaign', 'reactivate-campaign'].includes(statusHelperRole)
      "
      class="mx-auto"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="3" width="32" height="32" rx="16" fill="#E0EAFF" />
      <path
        d="M24.3334 25V23.6667C24.3334 22.9594 24.0525 22.2811 23.5524 21.781C23.0523 21.281 22.374 21 21.6667 21H16.3334C15.6262 21 14.9479 21.281 14.4478 21.781C13.9477 22.2811 13.6667 22.9594 13.6667 23.6667V25M21.6667 15.6667C21.6667 17.1394 20.4728 18.3333 19.0001 18.3333C17.5273 18.3333 16.3334 17.1394 16.3334 15.6667C16.3334 14.1939 17.5273 13 19.0001 13C20.4728 13 21.6667 14.1939 21.6667 15.6667Z"
        stroke="#444CE7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="3"
        y="3"
        width="32"
        height="32"
        rx="16"
        stroke="#E0EAFF"
        stroke-opacity="0.4"
        stroke-width="6"
      />
    </svg>
  </div>
</template>

<style scoped>
.backgroundImage {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0) 50%, #ffffff 100%),
    url('/img/illustration_helper_signup.png') no-repeat center center / cover;
}
</style>
